/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ParcelLpisIntersect } from './parcelLpisIntersect.model';
import { ParcelOwnershipJuristicTypeEntity } from './parcelOwnershipJuristicTypeEntity.model';
import { SubjectContactEntity } from './subjectContactEntity.model';
import { ChangeParcel } from './changeParcel.model';
import { ParcelZpochn } from './parcelZpochn.model';
import { Zpvypo } from './zpvypo.model';
import { DnepduosEntity } from './dnepduosEntity.model';
import { ParcelHeader } from './parcelHeader.model';


export interface Parcel { 
    accountingPrice?: number;
    acquisitionTax?: number;
    acquisitionTaxAdd?: number;
    budId?: number;
    buildingCustomNameActual?: string;
    buildingIdActual?: number;
    buildingNameActual?: string;
    buyPrice?: number;
    cena?: number;
    cenaPopis?: string;
    changeParcels?: Array<ChangeParcel>;
    cislKod?: number;
    cislNazev?: string;
    coefLocation?: number;
    dnepduos1?: DnepduosEntity;
    dnepduos1Acreage?: number;
    dnepduos1Year?: number;
    dnepduos2?: DnepduosEntity;
    dnepduos2Acreage?: number;
    dnepduos2Year?: number;
    dnepduos3?: DnepduosEntity;
    dnepduos3Acreage?: number;
    dnepduos3Year?: number;
    drupozKod?: number;
    drupozKodMan?: number;
    drupozNazev?: string;
    endDate?: string;
    id?: number;
    identBud?: string;
    inMyLb?: number;
    isDefunct?: boolean;
    isGeometry?: boolean;
    isLastVersion?: boolean;
    isOnSubcontract?: boolean;
    isOnValidOrProposalBarter?: boolean;
    isOwnedByConcerned?: boolean;
    isPartOwnedByConcernedAndRestRented?: boolean;
    isRentedAndFurtherRentPossible?: boolean;
    isWholeOwnedByConcerned?: boolean;
    isWholeRentedByConcerned?: boolean;
    katuzeKod?: number;
    katuzeKodPuv?: number;
    katuzeNazev?: string;
    katuzeNazevPuv?: string;
    koeficient: number;
    koeficientMan?: number;
    krajKod?: number;
    krajNazev?: string;
    lv?: number;
    maplis?: string;
    nazevZe?: string;
    nebonitovanaVymera?: number;
    obecKod?: number;
    obecNazev?: string;
    okresKod?: number;
    okresNazev?: string;
    osvobozenaVymera?: number;
    parId?: number;
    parType?: string;
    parcelHeader?: ParcelHeader;
    parcelLpisIntersect?: ParcelLpisIntersect;
    parcelOwnershipJuristicTypes?: Array<ParcelOwnershipJuristicTypeEntity>;
    parcelRentAveragePrice?: number;
    parcelRentFromAcreage?: number;
    parcelRentParcelPrice?: number;
    parcelZpochns?: Array<ParcelZpochn>;
    parcis?: string;
    parcisDil?: number;
    parcisKmen?: number;
    parcisPod?: number;
    priceAddAveragePrice?: number;
    priceAddAveragePricePercent?: number;
    priceAddParcelPrice?: number;
    priceAddParcelPricePercent?: number;
    pronajataVymera: number;
    prumernaCena?: number;
    realEstateBrokerage?: number;
    rentedByConcerned?: boolean;
    rentedByConcernedFurtherRent?: boolean;
    soucasti?: string;
    startDate?: string;
    tax?: number;
    taxAdd?: number;
    taxComputed?: number;
    taxFromRentedAcreage?: number;
    taxPayer?: SubjectContactEntity;
    taxPayerId?: number;
    taxTenant?: boolean;
    type?: number;
    typeValid?: number;
    useTaxFromRentedAcreage?: boolean;
    useTaxReturnDrupozKodOriginal?: boolean;
    vymera?: number;
    vymeraDoplneni?: number;
    zastavenaVymera?: number;
    zeKod?: number;
    zpevnenaPlochaX?: number;
    zpevnenaPlochaY?: number;
    zpurvyKod?: number;
    zpurvyNazev?: string;
    zpvypoKod?: number;
    zpvypoKodMan?: number;
    zpvypoManual?: Zpvypo;
    zpvypoNazev?: string;
}

